import userActions from "./userActions";
import languageActions from "./languageActions";
const allActions = {
  userActions,
  languageActions,
};

export default allActions;
